import type { FC } from 'react'
import { useState } from 'react'

import { Popup } from '@skytech/ui'
import PencilIcon from 'mdi-react/PencilIcon'

import { useAppContext } from '@/App.context'
import { useEditTranslationsPrivilege } from '@/hooks/user'

import { useTranslation } from '../hooks'

import { EditTranslationsForm } from './EditTranslationsForm'

import './index.styles.scss'

export const EditTranslations: FC<{ croppedId: string }> = ({ croppedId }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  const translate = useTranslation()
  const editTranslationsPrivilege = useEditTranslationsPrivilege()
  const { isEditTranslationsMode } = useAppContext()

  if (editTranslationsPrivilege === 'CANNOT_EDIT' || !isEditTranslationsMode) return null

  return (
    <>
      <PencilIcon
        className="edit-translation"
        tabIndex={0}
        role="button"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          setIsPopupOpen(true)
        }}
        onKeyDown={e => {
          e.preventDefault()
          e.stopPropagation()
          if (e.key === 'Enter') setIsPopupOpen(true)
        }}
      />

      <Popup
        ariaLabel={translate('Edit translations')}
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      >
        <EditTranslationsForm translationId={croppedId} onClose={() => setIsPopupOpen(false)} />
      </Popup>
    </>
  )
}
